module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "mobile-menu md:hidden"
  }, [_c('div', {
    staticClass: "mobile-menu-bar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.menuMobile
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "bars",
      "classname": "w-8 h-8 text-white transform -rotate-90"
    }
  })], 1)]), _vm._v(" "), (!_vm.openmenu) ? _c('ul', {
    staticClass: "border-t border-theme-29 py-5 d-block"
  }, [_c('app-side-bar', {
    attrs: {
      "classname": "menu"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('nav', {
    staticClass: "side-nav"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "side-nav__devider my-6"
  }), _vm._v(" "), _c('app-side-bar', {
    attrs: {
      "classname": "side-menu"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('app-top'), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-8"
  }, [_c('div', {
    staticClass: "col-span-12"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n              Administrativo\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box p-5 mt-6"
  }, [_c('div', {
    staticClass: "mt-1 grid grid-cols-5 gap-6"
  }, [_c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/budgets') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/budgets"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "briefcase",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n                  Presupuestos\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/clients') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/clients"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "file",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v(" Clientes\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/suppliers') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/suppliers"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "grid",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n                  Proveedores\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/social-reasons') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/social-reasons"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "briefcase",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n                  Razones Sociales\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/campaigns') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/campaigns"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "file",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v(" Campañas\n                ")], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12"
  }, [_c('router-view')], 1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "flex mr-auto",
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "alt": "My Inxait",
      "src": "/static/images/logo.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "intro-x flex items-center pl-5 pt-4",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "w-32 xl:block",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2035a740","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminBusiness.vue
// module id = 417
// module chunks = 1